import PropTypes from 'prop-types';
import React, { Component } from 'react';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

const MONEY_BUTTON_JS_URL = 'https://www.moneybutton.com/moneybutton.js';
let onlyOneExecution = null;

const loadMoneyButtonJs = async ({
  url = MONEY_BUTTON_JS_URL
} = {}) => {
  if (onlyOneExecution !== null) {
    return onlyOneExecution;
  }

  const promise = new Promise(resolve => {
    if (typeof window === 'undefined') {
      throw new Error('This library is meant to use in the browser');
    }

    if (window.moneyButton) {
      return resolve(window.moneyButton);
    }

    const aScript = document.createElement('script');
    aScript.type = 'text/javascript';
    aScript.src = url;
    document.head.appendChild(aScript);

    aScript.onload = () => {
      resolve(window.moneyButton);
    };
  });
  onlyOneExecution = promise;
  return promise;
};

const MONEY_BUTTON_JS_URL$1 = 'https://www.moneybutton.com/moneybutton.js';
class MoneyButton extends Component {
  constructor(_props) {
    super(_props);

    _defineProperty(this, "iframeLoader", async () => {
      return loadMoneyButtonJs({
        url: this.props.mbJsUrl || MONEY_BUTTON_JS_URL$1
      });
    });

    _defineProperty(this, "refreshMoneyButton", async props => {
      const iframeLoader = await this.iframeLoader();

      if (!this.ref) {
        return;
      }

      iframeLoader.render(this.ref, this.createParams(props));
    });

    _defineProperty(this, "createParams", props => {
      return {
        to: props.to,
        asset: props.asset,
        amount: props.amount,
        currency: props.currency,
        label: props.label,
        successMessage: props.successMessage,
        opReturn: props.opReturn,
        outputs: props.outputs,
        cryptoOperations: props.cryptoOperations,
        onCryptoOperations: props.onCryptoOperations,
        clientIdentifier: props.clientIdentifier,
        buttonId: props.buttonId,
        buttonData: props.buttonData,
        type: props.type,
        onPayment: props.onPayment,
        onError: props.onError,
        onLoad: props.onLoad,
        editable: props.editable,
        disabled: props.disabled,
        devMode: props.devMode,
        preserveOrder: props.preserveOrder
      };
    });

    _defineProperty(this, "setRef", r => {
      this.ref = r;
    });

    this.ref = null;
  }

  async componentDidMount() {
    await this.refreshMoneyButton(this.props);
  }

  shouldComponentUpdate(nextProps) {
    this.refreshMoneyButton(nextProps);
    return false;
  }

  render() {
    return /*#__PURE__*/React.createElement("div", {
      ref: this.setRef
    });
  }

}

_defineProperty(MoneyButton, "propTypes", {
  to: PropTypes.string,
  asset: PropTypes.string,
  amount: PropTypes.string,
  editable: PropTypes.bool,
  currency: PropTypes.string,
  label: PropTypes.string,
  hideAmount: PropTypes.bool,
  opReturn: PropTypes.string,
  outputs: PropTypes.array,
  cryptoOperations: PropTypes.array,
  onCryptoOperations: PropTypes.func,
  clientIdentifier: PropTypes.string,
  buttonId: PropTypes.string,
  buttonData: PropTypes.string,
  type: PropTypes.string,
  onPayment: PropTypes.func,
  onError: PropTypes.func,
  onLoad: PropTypes.func,
  devMode: PropTypes.bool,
  preserveOrder: PropTypes.bool,
  mbJsUrl: PropTypes.string
});

export default MoneyButton;
//# sourceMappingURL=index.es.js.map
